import { i18n } from "../main";

export function getHeader(token) {
  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
  };

  return headers;
}

export const getToken = (name) => {
  const cookie = {};
  document.cookie.split(";").forEach((el) => {
    const [k, v] = el.split("=");
    cookie[k.trim()] = v;
  });
  return cookie[name];
};

export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts.length == 2) {
    return parts
      .pop()
      .split(";")
      .shift();
  }
};

export const deleteCookie = (name) => {
  const cookie = `${name}=;domain=${process.env.VUE_APP_COOKIE_DOMAIN};path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;max-age=-1;samesite=none;secure;`;
  document.cookie = cookie;
};

export const timeSince = (time) => {
  const DATE_TIME = new Date(time);
  const SECONDS = Math.floor((new Date() - DATE_TIME) / 1000);

  let interval = Math.floor(SECONDS / 31536000);
  if (interval >= 1) {
    return i18n.tc("timestamps.YEARS_AGO", interval);
  }

  interval = Math.floor(SECONDS / 2592000);
  if (interval >= 1) {
    return i18n.tc("timestamps.MONTHS_AGO", interval);
  }

  interval = Math.floor(SECONDS / 86400);
  if (interval >= 1) {
    return i18n.tc("timestamps.DAYS_AGO", interval);
  }

  interval = Math.floor(SECONDS / 3600);
  if (interval >= 1) {
    return i18n.tc("timestamps.HOURS_AGO", interval);
  }

  interval = Math.floor(SECONDS / 60);
  if (interval >= 1) {
    return i18n.tc("timestamps.MINUTES_AGO", interval);
  }
  return `${i18n.t("timestamps.MOMENT_AGO")}`;
};

export const formatDate = (date) => {
  const fDate = new Date(date);
  const dateOptions = { year: "numeric", month: "long", day: "numeric" };
  const ymd = fDate.toLocaleDateString(navigator.language, dateOptions);

  return ymd;
};
